import { useEffect, useState } from 'react';

export const useFixedHeader = (offSet: number) => {
  const [isFixed, setIsFixed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.scrollingElement?.scrollTop ?? 0;
      const mustBeFixed = scrollTop > offSet;
      if (mustBeFixed) {
        !isFixed && setIsFixed(true);
      } else {
        isFixed && setIsFixed(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isFixed, offSet]);

  return {
    isFixed,
  };
};
